import { DialogContentComponent } from "../dialog-instance/types/DialogContentComponent";

export const SimpleTextDialogContent: DialogContentComponent<{ message: string }> = ({ instance, describedById }) => {
    return <p id={describedById}>{instance.model.message}</p>;
};
